import { ChangeDetectionStrategy, Component } from '@angular/core'
import { AuthService } from '@features/auth/auth.service'
import { Router, RouterLink } from '@angular/router'
import { map, shareReplay } from 'rxjs'
import { ClientService } from '@features/client/client.service'
import { APP_ROUTE_NAMES } from '@app/app.routes'
import { MatSnackBar } from '@angular/material/snack-bar'
import { BusinessModeToggleService } from '@features/business-mode-toggle/business-mode-toggle.service'
import { ClientIdentityPipe } from './client-identity.pipe'
import { MatMenuModule } from '@angular/material/menu'
import { AsyncPipe, NgTemplateOutlet } from '@angular/common'
import { LanguageSelectorComponent } from '../i18n/language-selector/language-selector.component'
import { MatIconModule } from '@angular/material/icon'
import { MatButton } from '@angular/material/button'
import { MatToolbarModule } from '@angular/material/toolbar'
import { LogoComponent } from '@features/logo/logo.component'
import { MenuLogoComponent } from '@features/menu-icon/menu-icon.component'

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatToolbarModule, MatButton, RouterLink, MatIconModule, LanguageSelectorComponent, MatMenuModule, NgTemplateOutlet, AsyncPipe, ClientIdentityPipe, LogoComponent, MenuLogoComponent]
})
export class HeaderComponent {

  readonly hasToken$ = this.auth.token$.pipe(map(token => Boolean(token)))

  readonly profile$ = this.client.profile$.pipe(shareReplay(1))

  constructor(private auth: AuthService,
              private client: ClientService,
              private router: Router,
              private snackBar: MatSnackBar,
              public businessMode: BusinessModeToggleService,
  ) { }

  logout(): void {
    this.snackBar.open(
      $localize`:navbar|Logout message:You have logged out.`,
    )
    this.auth.logout()
    this.navigateToLogin()
  }

  navigateToLogin(): void {
    this.router.navigate(['/', APP_ROUTE_NAMES.LOGIN])
  }
}
